import React from 'react';
import Text from '../Text';

const TAG_SIZE_MAP = {
  monkey: 'h1',
};

const Title = (props) => {
  const { size } = props;
  const tag = TAG_SIZE_MAP[size];

  return <Text {...props} tag={tag} />;
};

export default Title;
